import StoryArrowIcon from '@/assets/story-arrow.svg?react'
import StoryNavigationButton from './StoryNavigationButton'
import styles from './StoryNavigationControls.module.css'

export interface StoryNavigationControlsProps {
	navigation: {
		canPreviousStory: boolean
		canNextStory: boolean
	}
	interactionDisabled?: boolean
	onPreviousStory: () => void
	onNextStory: () => void
}

export default function StoryNavigationControls({
	navigation,
	interactionDisabled = false,
	onPreviousStory,
	onNextStory,
}: StoryNavigationControlsProps) {
	const previousDisabled = interactionDisabled || !navigation.canPreviousStory
	const nextDisabled = interactionDisabled || !navigation.canNextStory

	return (
		<div className={styles.storyControls}>
			<StoryNavigationButton
				className={styles.storyControlButton}
				label="查看上一条日记"
				disabled={previousDisabled}
				onClick={onPreviousStory}
			>
				<StoryArrowIcon className={styles.arrowUp} aria-hidden="true" />
			</StoryNavigationButton>
			<StoryNavigationButton
				className={styles.storyControlButton}
				label="查看下一条日记"
				disabled={nextDisabled}
				onClick={onNextStory}
			>
				<StoryArrowIcon className={styles.arrowDown} aria-hidden="true" />
			</StoryNavigationButton>
		</div>
	)
}
